export default __webpack_public_path__ + "static/media/025-car.dc1f1d5c.svg";